import React, { useRef, useState, useEffect, useContext } from "react";
import styles from "styles/page.module.scss";
import { Button, Spinner, Notifications, Alert } from "components";
import { Scrollbars } from "react-custom-scrollbars";
import { useTransition, animated } from "react-spring";
import useReactRouter from "use-react-router";
import { WithPageScrollProvider } from "context/PageScrollContext";
import { API } from "aws-amplify";
import { Redirect } from "@shopify/app-bridge/actions";
import classNames from "lib/classNames";
import EmbeddedContext from "context/EmbeddedContext";
import ShopContext from "context/ShopContext";

export const PageHeader = ({ style = {}, title, actions = [] }) => {
  return (
    <div
      className={classNames("flex items-center px-6 p-2 bg-white")}
      style={{ ...style, height: 48 }}
    >
      <h3
        className={
          classNames("flex-1 capitalize text-gray-600 text-lg font-bold") +
          ` ${styles.page_header}`
        }
      >
        {title}
      </h3>
      {!!actions.length &&
        actions.map((action, index) => {
          if (typeof action === "function") return action(index);
          if (!action.type) action.type = "circle-icon__primary";
          return <Button {...action} className={styles.action} key={index} />;
        })}
    </div>
  );
};

const Page = ({
  header = false,
  TopContent = null,
  children,
  loading = false,
  background = "#f6f7fb",
  height= false,
  padding = "",
  onScroll = null,
  getScrollTop
}) => {
  const [isActive, setIsActive] = useState(true)
  const scrollbars_ref = useRef(null);
  const [error, setError] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  
  const { AppBridgeRedirect } = useContext(EmbeddedContext);
  const {
    state: { id: shopName }
  } = useContext(ShopContext);
  useEffect(() => {
    if (getScrollTop && scrollbars_ref.current) {
      getScrollTop(scrollbars_ref.current);
    }
  }, [scrollbars_ref]);

  return (
    <div 
      className={styles.app_container} 
      style={{background}}
    >
      {header && TopContent && (
        <div className={styles.topBarWrapper}>
          {TopContent.transitions.map(({ item, key, props }) => {
            return item ? (
              <animated.div
                style={props}
                className={classNames("h-full")}
                key={key}
              >
                <TopContent.render
                  error={{
                    get: error,
                    set: setError
                  }}
                  loading={{
                    get: buttonLoading,
                    set: setButtonLoading
                  }}
                />
              </animated.div>
            ) : (
              <animated.div
                style={props}
                className={classNames("h-full")}
                key={key}
              >
                <PageHeader {...header} />
              </animated.div>
            );
          })}
        </div>
      )}
      {header && !TopContent && (
        <div className={styles.topBarWrapper}>
          <PageHeader {...header} />
        </div>
      )}
      <Scrollbars
        className={styles.customScrollbars}
        style={{
          height: height ? height : header ? "calc(100vh - 50px)" : "100vh"
        }}
        ref={scrollbars_ref}
        onScroll={() => {
          if (onScroll) onScroll(scrollbars_ref.current.getScrollTop());
          // localStorage.setItem('pst', scrollTop);
        }}
      >
        <WithPageScrollProvider pageScroll={scrollbars_ref}>
          <div className={classNames("relative h-full")}>
            {/* <Notifications /> */}
          
            <div
              className={classNames(
                "min-h-full relative",
                styles.page_content,
                padding || "p-6"
              )}
              id="page-content"
            >
              {!isActive &&
                <div className={classNames('mb-5')}>
                  <Alert 
                    type="warning" 
                    icon="exclamation-circle" 
                    title="Action Needed"  
                    actions={[
                      { text: "Enable Setting", onClick: () => AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, `https://${shopName}/admin/settings/checkout#post-purchase`) },
                      // { text: "Enable Setting", onClick: () => window.open(`https://${id}/admin/settings/checkout#post-purchase`,"_blank")  },
                      // { text: "Watch tutorial", onClick: () => window.open("https://www.loom.com/share/c2c79025c503404fbee62db2469f049e","_blank")}
                    ]}
                  >
                      <p>Please select “Monster Checkout” in the Shopify settings under the Post-Purchase page section. </p>
                      <p> This will make sure all live campaigns are shown to customers at checkout.</p>
                  </Alert>
                </div>
              }
              {loading.status ? (
                <Spinner text={loading.text || "page loading"} />
              ) : (
                children
              )}
            </div>
          </div>
        </WithPageScrollProvider>
      </Scrollbars>
    </div>
  );
};

export default Page;
